import { Component, OnInit } from '@angular/core';
import { Globals } from '../../globals';
import { ProductoService } from '../../servicios/producto.service'
import { MdcSnackbar } from '@angular-mdc/web';

@Component({
  selector: 'app-cotizaciones-cliente',
  templateUrl: './cotizaciones-cliente.component.html',
  styleUrls: ['./cotizaciones-cliente.component.scss']
})
export class CotizacionesClienteComponent implements OnInit {

	constructor(
		public globals: Globals,
		private productoService: ProductoService,
		private snackBar: MdcSnackbar,
	) { }

  cotizaciones = {
    cargando: false,
    registros: new Array()
  }

  ngOnInit(): void {
    if( this.globals.configuracion.front.usuario.cotizacion_cliente_id != '' ){
      this.cotizaciones.cargando = true;
      this.productoService.cotizacionesCliente().subscribe(
        resultado =>{
          if( !resultado.error ){
            Array.prototype.push.apply( this.cotizaciones.registros, resultado.registros );
            this.cotizaciones.cargando = false;
          }else{
            this.snackBar.open(resultado.mensaje, ' ', {
              dismiss: true
            });
          }

        },
        error =>{
          this.snackBar.open(`Error de conexión. Vuelva a intentarlo`, ' ', {
            dismiss: true
          });
          //this.feedProductos.cargando = false;
        }
      )
    }
  }

}
